import * as React from "react";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {InfoField} from "../../components/InfoField";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";
import {Display} from "../../../components/Display";
import {Loader} from "../../../components/Utils/loader/Loader";
import "./styles.scss"

interface InfoPageProps {

}

export const InfoPage: React.FC<InfoPageProps> = () => {
    const {deviceSlaveDetails, AppTranslations} = React.useContext(ReadAndWriteContext)
    const {isLoading, data, error} = deviceSlaveDetails;
    const model = data?.model;
    return (
        <div className={"info-main-container"}>
            <Display isVisible={isLoading}>
                <div>
                    <Loader relativelyCentered={true}/>
                </div>
            </Display>
            <Display isVisible={!isLoading && !error}>
                <div className={"row"}>
                    <VeBoxCard className={"Section rw-card"}>
                        <VeBoxCard.Header
                            className={"rw-card-header"}
                            titleClassName={"vebox-card-header-title"}
                            title={AppTranslations.readAndWrite.deviceSlaveSectionInfoTitle}
                            singleLineTitle={true}
                        />
                        <VeBoxCard.Body className={"rw-card-body no-padding"}>
                            <InfoField
                                valueClassName={"font-weight-400"}
                                labelClassName={"font-weight-300 "}
                                rootClassName={"padding-bottom-0 padding-left-10"}
                                label={AppTranslations.readAndWrite.deviceSlaveModelIdentifier}
                                value={data?.deviceSlaveModelIdentifier}
                            />

                            <InfoField
                                valueClassName={"font-weight-400"}
                                labelClassName={"font-weight-300"}
                                rootClassName={"padding-bottom-0 padding-left-10"}
                                label={AppTranslations.readAndWrite.deviceSalveType}
                                value={model?.typeName}
                            />
                            <InfoField
                                valueClassName={"font-weight-400"}
                                labelClassName={"font-weight-300 "}
                                rootClassName={"padding-bottom-0 padding-left-10"}
                                label={AppTranslations.readAndWrite.deviceSlaveCode}
                                value={data?.code}
                            />
                        </VeBoxCard.Body>
                    </VeBoxCard>
                    <VeBoxCard className={"Section rw-card"}>
                        <VeBoxCard.Header
                            className={"rw-card-header"}
                            titleClassName={"vebox-card-header-title"}
                            title={AppTranslations.readAndWrite.deviceSlaveSectionFunctionalityTitle}
                            singleLineTitle={true}
                        />
                        <VeBoxCard.Body className={"rw-card-body no-padding"}>
                            <InfoField
                                valueClassName={"font-weight-400"}
                                labelClassName={"font-weight-300"}
                                rootClassName={"padding-bottom-0 padding-left-10"}
                                label={AppTranslations.readAndWrite.deviceSlaveSectionDoorOpeningFunctionality}
                                value={data?.doorOpeningSupported ? AppTranslations.genericWords.supportedFemaleSingle : AppTranslations.genericWords.notSupportedFemaleSingle}
                                showStatus={true}
                                statusClassName={data?.doorOpeningSupported ? "available" : "disabled"}
                            />
                            <InfoField
                                valueClassName={"font-weight-400"}
                                labelClassName={"font-weight-300"}
                                rootClassName={"padding-bottom-0 padding-left-10"}
                                label={AppTranslations.readAndWrite.deviceSlaveSectionLockUnlockFunctionality}
                                value={data?.doorOpeningSupported ? AppTranslations.genericWords.supportedMaleSingle : AppTranslations.genericWords.notSupportedMaleSingle}
                                showStatus={true}
                                statusClassName={data?.lockSupported ? "available" : "disabled"}
                            />
                        </VeBoxCard.Body>
                    </VeBoxCard>
                </div>
            </Display>
        </div>
    );
};

